import { router } from '@inertiajs/vue3'

import type { ActionCategory } from '@/domains/command-center/types'

const getBillCategory = (): ActionCategory => ({
  id: 'cat-bills',
  label: 'Bills & Invoices',
  // `admin.finance.bills.new` sits behind `finance.view`, so this offers a 403 without it.
  permission: { action: 'view', subject: 'finance' },
  actions: [
    {
      id: 'action-bill-new',
      type: 'action',
      label: 'Create New Bill',
      icon: 'receipt',
      keywords: ['create', 'new', 'bill', 'invoice', 'supplier'],
      execute: () => router.get(route('admin.finance.bills.new')),
      onSuccess: 'closeMenu'
    }
  ]
})

export { getBillCategory }
